import React from "react";
import {
  Modal,
  Form,
  Input,
  Button,
  Row,
  Col,
  Typography,
} from "antd";
import {
  LockOutlined,
  UserOutlined,
} from "@ant-design/icons";

const { Title, Text } = Typography;

const UpdatePasswordModal = ({
  open,
  onClose,
  onSubmit,
  loading,
  form,
  lang,
}) => {
  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      width={640}
      centered
      destroyOnClose
      styles={{
        content: {
          borderRadius: 16,
          padding: 0,
          background: "#ffffff",
        },
      }}
    >
      {/* 🔹 Header */}
      <div
        style={{
          padding: "20px 24px",
          borderBottom: "1px solid #f0f0f0",
          display: "flex",
          alignItems: "center",
          gap: 12,
        }}
      >
        <div
          style={{
            width: 42,
            height: 42,
            borderRadius: "50%",
            background: "rgba(24,144,255,0.1)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <UserOutlined style={{ color: "#1890ff", fontSize: 18 }} />
        </div>

        <div>
          <Title level={4} style={{ margin: 0 }}>
            Update User Password
          </Title>
          <Text type="secondary" style={{ fontSize: 13 }}>
            Ensure the password meets security requirements
          </Text>
        </div>
      </div>

      {/* 🔹 Body */}
      <div style={{ padding: "24px" }}>
        <Form
          form={form}
          layout="vertical"
          onFinish={onSubmit}
        >
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="password"
                label="New Password"
                rules={[
                  { required: true, message: "Please enter password" },
                  {
                    validator: (_, value) => {
                      if (!value) return Promise.resolve();

                      const passwordRegex =
                        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>]).{8,}$/;

                      if (!passwordRegex.test(value)) {
                        return Promise.reject(
                          new Error(
                            "Min 8 chars with uppercase, lowercase, number & symbol",
                          ),
                        );
                      }
                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <Input.Password
                  prefix={<LockOutlined />}
                  placeholder="Enter new password"
                />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item
                name="confirm_password"
                label="Confirm Password"
                dependencies={["password"]}
                rules={[
                  { required: true, message: "Please confirm password" },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue("password") === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(
                        new Error("Passwords do not match"),
                      );
                    },
                  }),
                ]}
              >
                <Input.Password
                  prefix={<LockOutlined />}
                  placeholder="Confirm password"
                />
              </Form.Item>
            </Col>
          </Row>

          {/* 🔹 Footer */}
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 12,
              marginTop: 24,
            }}
          >
            <Button
              onClick={() => {
                form.resetFields();
                onClose();
              }}
              disabled={loading}
            >
              Cancel
            </Button>

            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              style={{
                borderRadius: 8,
                padding: "0 28px",
                fontWeight: 600,
              }}
            >
              Update Password
            </Button>
          </div>
        </Form>
      </div>
    </Modal>
  );
};

export default UpdatePasswordModal;
